"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carouselSlideWrapperStyles = void 0;
exports.carouselSlideWrapperStyles = {
    root: {
        height: "inherit",
        width: "100%",
        position: "relative",
    },
};
//# sourceMappingURL=styles.js.map